var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpotify(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "spotify_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21854",
    transform: "translate(1105 228)",
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1105 -228)",
    clipPath: "url(#spotify_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1117 230.999a9 9 0 109 9 9 9 0 00-9-9zm4.128 12.982a.561.561 0 01-.772.186c-2.11-1.291-4.774-1.584-7.91-.868a.561.561 0 01-.25-1.094c3.429-.784 6.37-.446 8.742 1a.561.561 0 01.19.776zm1.1-2.451a.7.7 0 01-.965.232 11.812 11.812 0 00-8.968-1.05.702.702 0 11-.408-1.343 13.131 13.131 0 0110.111 1.2.7.7 0 01.231.965zm.095-2.552c-2.9-1.723-7.687-1.881-10.457-1.041a.844.844 0 11-.488-1.615c3.179-.965 8.465-.779 11.8 1.2a.842.842 0 11-.859 1.448z"
  }))));
}
export default SvgSpotify;